import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import cn from 'classnames';

import * as styles from './MobileAppQRCode.css';

import { trackShow } from './tracking';

interface IMobileAppQRCodeProps {
  isNewBuilding: boolean;
}

export const MobileAppQRCode: React.FC<IMobileAppQRCodeProps> = ({ isNewBuilding }) => {
  return (
    <ActionAfterViewObserver callback={trackShow} triggerOnce>
      <div
        className={cn(styles['container'], isNewBuilding && styles['container-newbuilding'])}
        data-testid="MobileAppQRCode"
      >
        <div className={styles['img']} />
      </div>
    </ActionAfterViewObserver>
  );
};
